import { Container, Spinner } from "@chakra-ui/react"

import LaundryMainDetails from "./LaundryMainDetails"
import LaundryDiscount from "./LaundryDiscount"
import LaundryServices from "./LoundryServices/LaundryServices"
import LaundryAdditionalServices from "./LaundryAdditionalServices"
import LaundryFooter from "./LaundryFooter"
import useLaundry from "hooks/useLaundry"
import { useUI } from "providers/UIProvider"
import LaundryCommissionSettings from "./LaundryCommissionSettings"
import { useAppContext } from "providers/AppProvider/AppProvider"
import ReservationSettingsModal from "components/shared/modals/ReservationSettingsModal"
import ReservationCommissionModal from "components/shared/modals/ReservationCommissionModal"
import CancelReservationCommissionsModal from "components/shared/modals/CancelReservationCommissionsModal"
import { useLaundryContext } from "providers/LaundryProvider/LaundryProvider"

const LaundryTemplate = () => {
  const { isAdmin } = useAppContext()
  const { laundryDataLoading } = useLaundryContext()
  const { modals } = useUI()

  const accessToCommissionSettings = isAdmin;

  const {
    form: {
      values,
      errors,
      touched,
      handleChange,
      handleBlur,
      setValues,
      handleLogoChange,
      handle24Click,
      handleMapChange,
      handleSubmit,
      handleDenyClick
    },
    removeLogo,
    coordinates,
    setCoordinates,
    serviceData,
    updateServiceData,
    additionalServices,
    selectedAdditionalServices,
    handleAdditionalServiceClick,
    districtOptions,
    discountTypes,
    handleAddDiscount,
    handleDeleteDiscount
  } = useLaundry()


  if (laundryDataLoading) {
    return (
      <Container
        margin={0}
        width="100%"
        maxWidth="100%"
        bg="white"
        borderRadius="base"
        boxShadow="primary"
        padding="15px 20px"
        position="relative"
      >
        <Spinner />
      </Container>
    )
  }
  return (
    <Container
      margin={0}
      width="100%"
      maxWidth="100%"
      bg="white"
      borderRadius="base"
      boxShadow="primary"
      padding="15px 20px"
      position="relative"
    >
      <LaundryMainDetails
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        handleBlur={handleBlur}
        setValues={setValues}
        handleMapChange={handleMapChange}
        handleLogoChange={handleLogoChange}
        logo={values.logo}
        removeLogo={removeLogo}
        handle24Click={handle24Click}
        coordinates={coordinates}
        setCoordinates={setCoordinates}
        districtOptions={districtOptions}
      />
      <LaundryDiscount
        discountTypes={discountTypes}
        handleAddDiscount={handleAddDiscount}
        handleDeleteDiscount={handleDeleteDiscount} />
      <LaundryServices
        serviceData={serviceData}
        updateServiceData={updateServiceData}
        errors={errors}
        handleBlur={handleBlur}
        touched={touched}
        handleChange={handleChange}
        values={values}
      />
      <LaundryAdditionalServices
        additionalServices={additionalServices}
        selectedAdditionalServices={selectedAdditionalServices}
        handleAdditionalServiceClick={handleAdditionalServiceClick}
      />
      {accessToCommissionSettings && <LaundryCommissionSettings />}
      <LaundryFooter
        handleDeny={handleDenyClick}
        handleSubmit={handleSubmit}
      />
      {modals.reservationSettingsModal && <ReservationSettingsModal />}
      {modals.reservationCommissionModal && <ReservationCommissionModal />}
      {modals.cancelReservationCommissionModal && <CancelReservationCommissionsModal />}
    </Container>
  )
}

export default LaundryTemplate
